import {
  ApplNow,
  IReqTmarkRightsPage,
  TmarktypeOptions,
  TrademarkSearchNameOptions,
  TrademarkSearchNoOptions,
} from 'src/types/api/trademarkRightsApiTypes';

interface Iprops {
  reqParams: IReqTmarkRightsPage;
}
/**
 * 商標搜尋條件
 */
const TmarkSearchTip: React.FC<Iprops> = ({ reqParams }) => {
  return (
    <div>
      {reqParams.isEffective && (
        <>
          權利是否存續：
          {ApplNow[reqParams.isEffective as keyof typeof ApplNow]}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.searchNo && reqParams.searchNo.value && (
        <>
          {
            TrademarkSearchNoOptions.filter((item) => item.value === reqParams.searchNo?.keyWord)[0]
              .label
          }
          ：{reqParams.searchNo.value}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.regNoticeBDate && (
        <>
          公告日期：
          {reqParams.regNoticeBDate}
          {reqParams.regNoticeEDate && '~' + reqParams.regNoticeEDate}
          <span>｜</span>
          <br />
        </>
      )}

      {reqParams.tmarkName && (
        <>
          商標中英文名稱：
          {reqParams.tmarkName}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.searchName && reqParams.searchName.value && (
        <>
          {
            TrademarkSearchNameOptions.filter(
              (item) => item.value === reqParams.searchName?.keyWord,
            )[0].label
          }
          ：{reqParams.searchName.value}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.deadlineBDate && (
        <>
          專用期限：
          {reqParams.deadlineBDate}
          {reqParams.deadlineEDate && '~' + reqParams.deadlineEDate}
          <span>｜</span>
          <br />
        </>
      )}
      {reqParams.tmarkType && (
        <>
          商標樣態：
          {TmarktypeOptions.map((item) => {
            return item.value === reqParams.tmarkType && item.label;
          })}
          <span>｜</span>
          <br />
        </>
      )}
    </div>
  );
};

export default TmarkSearchTip;
